import { render, staticRenderFns } from "./loginSuccess.vue?vue&type=template&id=21ace279&scoped=true&"
import script from "./loginSuccess.vue?vue&type=script&lang=js&"
export * from "./loginSuccess.vue?vue&type=script&lang=js&"
import style0 from "./loginSuccess.vue?vue&type=style&index=0&id=21ace279&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ace279",
  null
  
)

export default component.exports